(() => {
  const pendingKey = 'mmy_catalogue_pending_v1';
  const readPending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(pendingKey));
      return value && Date.now() - value.at < 30 * 60 * 1000 ? value : null;
    } catch (_) { return null; }
  };
  const pending = readPending();
  const removePending = () => { try { sessionStorage.removeItem(pendingKey); } catch (_) {} };
  const dialogs = Array.from(document.querySelectorAll('[data-catalogue-dialog]'));
  let resumed = false;
  dialogs.forEach(dialog => {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const form = dialog.querySelector('form');
    const fields = dialog.querySelector('[data-catalogue-fields]');
    const success = dialog.querySelector('[data-catalogue-success]');
    const state = dialog.querySelector('[data-catalogue-server-state]');
    const triggers = document.querySelectorAll(`[data-catalogue-open="${dialog.id}"]`);
    let opener = triggers[0];
    const open = () => { if (!dialog.open) dialog.showModal(); };
    triggers.forEach(trigger => { trigger.disabled = false; trigger.addEventListener('click', () => {
      opener = trigger;
      fields.hidden = false;
      success.hidden = true;
      dialog.querySelector('[data-catalogue-errors]').hidden = true;
      open();
      form.querySelector('input:not([type="hidden"])').focus();
    }); });
    dialog.querySelector('[data-catalogue-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus());
    form.addEventListener('submit', () => {
      // Keep Shopify's native submit and CAPTCHA flow. Never unlock on a click or HTTP status alone.
      try { sessionStorage.setItem(pendingKey, JSON.stringify({ id: form.id, at: Date.now() })); } catch (_) {}
    });
    const returnedToThisForm = location.hash === `#${form.id}` ||
      (pending?.id === form.id && (!location.hash || location.hash === '#contact_form'));
    if (!returnedToThisForm) return;
    if (state.dataset.success === 'true' && success.querySelector('a')) {
      fields.hidden = true;
      success.hidden = false;
      open();
      success.focus();
      resumed = true;
      removePending();
    } else if (state.dataset.error === 'true') {
      open();
      dialog.querySelector('[data-catalogue-errors]').hidden = false;
      resumed = true;
    }
  });
  // Shopify contact form state is shared by forms on a page. Keep catalogue feedback in its dialog.
  if (resumed) document.querySelectorAll('[data-rfq-feedback]').forEach(el => { el.hidden = true; });
  document.querySelectorAll('form').forEach(form => {
    if (form.closest('[data-catalogue-dialog]')) return;
    if (form.querySelector('[name="form_type"][value="contact"]')) form.addEventListener('submit', removePending);
  });
})();
